"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
require("core-js/modules/es6.string.link.js");
var _react = _interopRequireWildcard(require("react"));
var _apollo = require("@nerdwallet/apollo");
var _baseImpression = _interopRequireDefault(require("./base-impression"));
var _graphqlMarketplaceProductCard = _interopRequireDefault(require("../graphql-marketplace-product-card"));
var _generatedTypes = require("../types/graphql/generated-types");
var _templateObject;
/**
 * ImpressionContext can result in many rerenders of the card.
 */
var MemoizedGraphQlMarketplaceProductCard = /*#__PURE__*/(0, _react.memo)(_graphqlMarketplaceProductCard.default);

/**
 * Get true destination url based on override config.
 */
var getDestinationUrl = function getDestinationUrl(_ref) {
  var ctaOverride = _ref.ctaOverride,
    ctaFallback = _ref.ctaFallback,
    reviewLinkOverride = _ref.reviewLinkOverride;
  var getCtaLink = function getCtaLink(cta) {
    return (cta === null || cta === void 0 ? void 0 : cta.type) === _generatedTypes.EntityPlacementCtaTypeEnum.ReadReview ? reviewLinkOverride || (cta === null || cta === void 0 ? void 0 : cta.link) : cta === null || cta === void 0 ? void 0 : cta.link;
  };
  return ctaOverride ? getCtaLink(ctaOverride) : getCtaLink(ctaFallback);
};
/**
 * The GraphQL Marketplace Product Card with Product Impression logic.
 */
var GraphQlMarketplaceProductCardImpression = function GraphQlMarketplaceProductCardImpression(props) {
  var _gqlMarketplaceEntity, _gqlMarketplaceEntity2, _gqlMarketplaceEntity3;
  var analytics = props.analytics,
    cta = props.cta,
    gqlMarketplaceEntity = props.gqlMarketplaceEntity,
    reviewLinkHref = props.reviewLinkHref,
    trkElementPosition = props.trkElementPosition,
    trkSectionPosition = props.trkSectionPosition,
    trkSectionCategory = props.trkSectionCategory;
  return /*#__PURE__*/_react.default.createElement(_baseImpression.default, {
    analytics: analytics === null || analytics === void 0 ? void 0 : analytics.productImpressionProps,
    destinationUrl: getDestinationUrl({
      ctaOverride: cta,
      ctaFallback: gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.cta,
      reviewLinkOverride: reviewLinkHref
    }),
    elementPosition: trkElementPosition,
    sectionPosition: trkSectionPosition,
    sectionName: trkSectionCategory,
    marketplaceInstitutionId: gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : (_gqlMarketplaceEntity = gqlMarketplaceEntity.analyticsProps) === null || _gqlMarketplaceEntity === void 0 ? void 0 : _gqlMarketplaceEntity.institutionId,
    marketplaceOfferId: gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : (_gqlMarketplaceEntity2 = gqlMarketplaceEntity.analyticsProps) === null || _gqlMarketplaceEntity2 === void 0 ? void 0 : _gqlMarketplaceEntity2.offerId,
    marketplaceProductId: gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : (_gqlMarketplaceEntity3 = gqlMarketplaceEntity.analyticsProps) === null || _gqlMarketplaceEntity3 === void 0 ? void 0 : _gqlMarketplaceEntity3.productId,
    marketplaceProductType: gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.productType
    // todo: centralize types
    ,
    monetizable: gqlMarketplaceEntity === null || gqlMarketplaceEntity === void 0 ? void 0 : gqlMarketplaceEntity.monetizable
  }, /*#__PURE__*/_react.default.createElement(MemoizedGraphQlMarketplaceProductCard, props));
};
if (process.env.NODE_ENV !== 'production') {
  /* eslint-disable-next-line global-require, @typescript-eslint/no-var-requires */
  var PropTypes = require('prop-types');
  var _require = require('../prop-types'),
    EntityPlacementCtaPropType = _require.EntityPlacementCtaPropType,
    MarketplaceProductCardAnalyticsPropType = _require.MarketplaceProductCardAnalyticsPropType; // eslint-disable-line global-require, @typescript-eslint/no-var-requires

  GraphQlMarketplaceProductCardImpression.propTypes = {
    analytics: MarketplaceProductCardAnalyticsPropType,
    cta: EntityPlacementCtaPropType,
    gqlMarketplaceEntity: PropTypes.shape({
      analyticsProps: PropTypes.shape({
        offerId: PropTypes.string,
        productId: PropTypes.string,
        institutionId: PropTypes.string
      }),
      cta: EntityPlacementCtaPropType,
      monetizable: PropTypes.string,
      productType: PropTypes.string
    }),
    reviewLinkHref: PropTypes.string,
    trkElementPosition: PropTypes.number,
    trkSectionCategory: PropTypes.string,
    trkSectionPosition: PropTypes.number
  };
}
GraphQlMarketplaceProductCardImpression.fragment = (0, _apollo.gql)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  fragment GraphQlMarketplaceProductCardImpression on MarketplaceEntityInterface {\n    productType\n    ... on MarketplaceEntityWithPlacementInterface {\n      analyticsProps {\n        offerId\n        productId\n        institutionId\n      }\n      monetizable\n    }\n    ...GraphQlMarketplaceProductCard\n  }\n  ", "\n"])), _graphqlMarketplaceProductCard.default.fragment);
var _default = GraphQlMarketplaceProductCardImpression;
exports.default = _default;